import React from 'react';
import { Messages, Control, API, Code, Name, Title, Actions, Form, Hooks, Files, Toast, Button, useListContext, useCallback, useEffect, useState, Utility } from 'helpers/ListImports';
import { Project } from 'models/ProjectModel';
import { ControlSession } from 'components/common/ControlSession';


const ProjectList: React.FC = () => {
  const width = { serial: 8, type: 14, clientname: 18, address: 20, status:16, modifyon:10, modifyby:14 }
  const [formId, formName] = [Code.Form.Id.PROJECT, Code.Form.Name.PROJECT];
  const { loading, setLoading, error, setError, search, setSearch, pno, setPno, pageRows, setPageRow, activeId, setActiveId, selected, setSelected, confirm, setConfirm, message, setMessage,  showMenu, setShowMenu, selectedItems, setSelectedItems, selectAllChecked, setSelectAllChecked, activeOptions, setActiveOptions, rowOptions, setRowOptions, menuPosition, setMenuPosition, iframeRef, filterRef, contextMenuRef  } = useListContext();
  const [projectData, setProjectData] = useState<Project[]>([]); 
  const [selectedProject, setselectedProject] = useState<Project | null>(null);
  const [statusId, setStatusId] = useState<number>(Code.Option.Common.ALL);
  const [typeId, setTypeId] = useState<number>(Code.Option.Common.ALL);
  const [statusOptions, setStatusOptions] = Hooks.Form.Options();
  const [typeOptions, setTypeOptions] = Hooks.Form.Options();
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');
  const triggers = [pno, pageRows, search, activeId, statusId, typeId, startDate, endDate];
  const Privilege = Hooks.Privilege.List(formId);
  const PrivClient = Hooks.Privilege.List(Code.Form.Id.CLIENT);
  const locationId = Utility.Storage.LocationId();

  Hooks.Privilege.HasView(Privilege);
  
  Form.Click.Outside([contextMenuRef, filterRef],[() => setShowMenu(false),() => {}],true);
  Form.Select.OnChange(selectedItems, setSelected);

  useEffect(() => {
    Files.Json.API(Code.File.OPTION+Code.Group.PROJECT_STATUS, Code.Option.Common.ALL, setStatusOptions, setError);
    Files.Json.API(Code.File.OPTION+Code.Group.PROJECT_TYPE, Code.Option.Common.ALL, setTypeOptions, setError);
    Files.Json.Http(Code.File.ACTIVE, Code.Option.Common.NOTHING, setActiveOptions, setError);
    Files.Json.Http(Code.File.ROW, Code.Option.Common.NOTHING, setRowOptions, setError);
  }, []);

  useEffect(() => {
    callListData(); 
  }, triggers);

  useEffect(() => {
    console.log("projectData:",projectData);
  }, [projectData]);
 
  const callListData = useCallback(async () => {
    const url = API.Build.ListApiEndpoint(formName, pno, pageRows, Name.Project.Date, Code.Option.Sort.DESC, activeId, search, {
      fields: Utility.Join.Fields([
        Name.Project.Id, 
        Name.Project.Number, 
        Name.Common.TypeName, 
        Name.Client.Id, 
        Name.Client.FullName, 
        Name.Client.Address, 
        Name.Client.Phone, 
        Name.Common.StatusName, 
        Name.Project.Date, 
        Name.Common.ModifyName, 
      ]),
      ...(!Privilege.ALLLOC && { location_id: locationId }),
      ...(statusId != 1 && { status_id: statusId }),
      ...(typeId != 1 && { type_id: typeId }),
      ...(startDate != '' && { start_date: startDate }),
      ...(endDate != '' && { end_date: endDate }),
    });
     
    await API.Data.List<Project>(url, setProjectData, setError, setLoading); 
  }, triggers);

  return (
    <Control.List.Frame>
      <Control.List.Panel>
        <Control.List.Tools>
          <Control.Tool.Left>
            <Button.Create title={formName} onClick={() => Form.Show.Popup(iframeRef, formName)} Privilege={Privilege} />
            {selected && ( <Button.Delete onClick={()=>Toast.Delete.MultipleRecords(activeId, selectedItems, setConfirm)} activeId={activeId} Privilege={Privilege} /> )}
          </Control.Tool.Left>
          <Control.Tool.Right>
            <Control.SearchBar onSearch={setSearch} onFilterToggle={() => Form.Show.Filter(filterRef)}  onGoClick={() => callListData()} />
            <Control.List.Filter filterRef={filterRef}>
              <ControlSession startDate={startDate} setStartDate={setStartDate} endDate={endDate} setEndDate={setEndDate} />
              <Control.Dropdown title={Title.Status} value={statusId} options={statusOptions} onChange={setStatusId} />
              <Control.Dropdown title={Title.Type} value={typeId} options={typeOptions} onChange={setTypeId} />
              <Control.Dropdown title={Title.Status} value={activeId} options={activeOptions} onChange={setActiveId} />
              <Control.Dropdown title={Title.Rows} value={pageRows} options={rowOptions} onChange={setPageRow} />
            </Control.List.Filter>
            <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.MultiDelete(formName, activeId, callListData, selectedItems, setConfirm, setMessage, setSelected, setSelectedItems, setError) } onRefuse={() => setSelectedItems([])} />
          </Control.Tool.Right>
        </Control.List.Tools>
        <Control.List.Data>
          <Control.List.Box>
            <Control.List.Title>
              <Control.SelectAll selectAllChecked={selectAllChecked} onSelectAll={(e) => Form.Select.All(e, setSelectedItems, projectData, setSelectAllChecked,formName)} extra={1} />
              <Control.Grid.Items values={[
                [Title.ProjectName, width.serial], 
                [Title.Type, width.type], 
                [Title.ClientName, width.clientname], 
                [Title.Address, width.address], 
                [Title.State, width.status], 
                [Title.ModifiedOn, width.modifyon], 
                [Title.ModifiedBy, width.modifyby], 
              ]} last={1} upper={true} />
            </Control.List.Title>
            {!loading && !error && Array.isArray(projectData) && (
              <Control.Grid.Row>
                {projectData.map((projectData) => { return (
                <Control.Grid.Data<Project> key={projectData.project_id} itemKey={projectData.project_key} data={projectData} setMenuPosition={setMenuPosition} setSelectedData={setselectedProject} setShowMenu={setShowMenu} >
                  <Control.Grid.Check keyId={projectData.project_key} selectedItems={selectedItems} toggleSelection={Form.Select.Toggle} setSelectedItems={setSelectedItems} />
                  <Control.Grid.Modify path={Utility.Join.Edit(Privilege, formName, projectData.project_key)} iframeRef={iframeRef} Privilege={Privilege} />
                  <Control.Grid.Items values={[
                    [`#${projectData.project_number?.replace("0000","")}`, width.serial],
                    [projectData.type_name, width.type],
                  ]} />
                  <Control.Grid.Link value={Utility.Get.FullName(projectData,Code.Form.Name.CLIENT)} path={Utility.Join.Edit(PrivClient, Code.Form.Name.CLIENT, projectData.client_id)} width={width.clientname} iframeRef={iframeRef} /> 
                  <Control.Grid.Items values={[
                    [projectData.client_address, width.address],
                    [projectData.status_name, width.status],
                    [Utility.Format.DateOnly(projectData.project_date), width.modifyon],
                    [projectData.modify_name, width.modifyby],
                  ]} />
                  <Control.Grid.Actions>
                    <Control.Action.All formName={formName} activeId={activeId} keyId={projectData.project_key} iframeRef={iframeRef} setSelectedItems={setSelectedItems} setConfirm={setConfirm} Privilege={Privilege}><></></Control.Action.All>
                  </Control.Grid.Actions>
                </Control.Grid.Data>)})}
            </Control.Grid.Row>)}
          </Control.List.Box>
        </Control.List.Data>
        <Control.List.Info>
          <Control.RecordInfo pageNo={pno} pageRows={pageRows} loading={loading} error={error} dataLength={projectData.length} />
          <Control.Pagination pageNo={pno} onChange={(page) => setPno(page)} />
        </Control.List.Info>
      </Control.List.Panel>
      {showMenu && (<div ref={contextMenuRef}><Control.ListContextMenu showMenu={showMenu} formName={formName} onCreate={() => Form.Show.Popup(iframeRef, formName)} onModify={()=>Form.Show.Popup(iframeRef, Utility.Join.Edit(Privilege, formName,selectedProject?.project_key))} onDelete={() => Toast.Delete.SingleRecord(activeId, selectedProject?.project_key, setSelectedItems, setConfirm)} onClose={() => Form.Parent.TabClose()} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Control.FormPopup iframeRef={iframeRef} onRefresh={callListData} />
      <Actions.List />
    </Control.List.Frame>
  );
};

export default ProjectList;